import { Flex, Group, Text } from '@mantine/core';
import { useEffect } from 'react';
import {
  TCommercialProposal,
  useListCommercialProposals,
} from '@/models/commercial-proposal';
import { semanticJurisdiction } from '@/lib/helpers';
import classes from './ProposalList.module.css';

export interface ProposalListProps {
  onSelect: (proposal: TCommercialProposal) => void;
  term?: string;
  jurisdiction?: string;
  page: number;
  onPaginationInfo?: (info: { total: number; totalPages: number }) => void;
}

export default function ProposalList({
  onSelect,
  term,
  jurisdiction,
  page,
  onPaginationInfo,
}: ProposalListProps) {
  const { data, isLoading } = useListCommercialProposals({
    page,
    limit: 20,
    isDraft: false,
    term: term || undefined,
    jurisdiction: jurisdiction || undefined,
    sortBy: 'updatedAt',
    sortOrder: 'desc',
  });

  const proposals = data?.proposals ?? [];
  const total = data?.total ?? 0;
  const totalPages = data?.totalPages ?? 0;

  useEffect(() => {
    if (!isLoading && onPaginationInfo) {
      onPaginationInfo({ total, totalPages });
    }
  }, [isLoading, total, totalPages, onPaginationInfo]);

  if (isLoading) {
    return (
      <Text ta="center" py="xl">
        Loading proposals...
      </Text>
    );
  }

  if (proposals.length === 0) {
    return (
      <Text ta="center" py="xl">
        No proposals found
      </Text>
    );
  }

  return (
    <>
      {proposals.map((proposal) => (
        <Flex
          gap={0}
          key={proposal.id}
          onClick={() => onSelect(proposal)}
          justify="space-between"
          className={classes.item}
        >
          <Group gap={4}>
            <Text size="xs" m={0}>
              {proposal.name}
            </Text>
            <Text fz="xs" c="dimmed">
              {semanticJurisdiction(proposal.jurisdiction)}
            </Text>
          </Group>
          <Text size="xs" m={0} c="dimmed">
            {proposal.currency}
          </Text>
        </Flex>
      ))}
    </>
  );
}
